import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isRecorderPaused: false
}

export const recorderSlice = createSlice({
    name:'recorder',
    initialState,
    reducers: {
        setIsRecorderPaused:(state, action) => {
            state.isRecorderPaused = !state.isRecorderPaused
        }
    }
})

export const { setIsRecorderPaused } = recorderSlice.actions;
export default recorderSlice.reducer;